import Axios from 'axios';
import { StandardError } from 'base/api/errors';
import apiUrls from 'base/api/urls';
import { useAuthStore } from 'common/hooks';
import Cookies from 'js-cookie';
import { ACCESS_TOKEN, REFRESH_TOKEN } from 'modules/auth/consts';
import { useRole } from 'modules/auth/queries';
import { useMutation } from 'react-query';
import { clearAuthState } from '../../base/api/utils';

type SSOLoginVars = {
  verification_key: string | string[] | null;
};

type LoginResponse = {
  [ACCESS_TOKEN]: string;
  refresh_token: string;
  token_type: 'Bearer';
  access_expires_at: number;
  refresh_expires_at: number;
  expires_in: number;
  expires_at: number;
  sub: string;
};

export const useFrieslandSSOLogin = () => {
  const { refetch: getRole } = useRole();
  const { revalidate } = useAuthStore(({ revalidate }) => ({
    revalidate,
  }));
  return useMutation<LoginResponse, StandardError, SSOLoginVars>(
    (data) => Axios.post(apiUrls.AUTH.SSO_LOGIN, data),
    {
      onSuccess: (data) => {
        revalidate();
        getRole();
        Cookies.set(ACCESS_TOKEN, data[ACCESS_TOKEN], {
          expires: new Date(data.expires_at),
          sameSite: 'Strict',
          secure: true,
        });
        Cookies.set(REFRESH_TOKEN, data.refresh_token, {
          expires: new Date(data.refresh_expires_at),
          sameSite: 'Strict',
          secure: true,
        });
      },
      onError: () => {
        clearAuthState();
      },
    },
  );
};
